
const ESPERANDO_CONFIRMACION = '1'
const ACEPTADO = '2'
const DEVUELTO = '3'
const MODIFICADO = '4'
const SUSPENDIDO = '5'
const RECHAZADO = '6'

export default {
  ESPERANDO_CONFIRMACION: ESPERANDO_CONFIRMACION,
  ACEPTADO: ACEPTADO,
  DEVUELTO: DEVUELTO,
  MODIFICADO: MODIFICADO,
  SUSPENDIDO: SUSPENDIDO,
  RECHAZADO: RECHAZADO
}



// WEBPACK FOOTER //
// ./src/config/data_status.js